<form [formGroup]="form">
  <div class="mb-3 row">
    <label class="col-md-4 col-form-label" for="text-input">{{'project_settings.label.project_name' | translate}}</label>
    <div class="col-md-8">
      <input
        appInputAutoFocus
        spellcheck="false"
        type="text"
        id="project_name"
        placeholder="{{'header.menu.new_project' | translate}}"
        name="text-input"
        class="form-control"
        formControlName="projectName"
        data-testid="project-properties-name"
        (blur)="markDirty(getProjectNameFormControl())"
        [readonly]="!editEnabled"
        [class.is-invalid]="checkControlValidity(getProjectNameFormControl())">
      <div class="invalid-feedback">{{ form.controls.projectName.errors?.messageKey | translate:{'0':form.controls.projectName.errors?.param} }}</div>
    </div>
  </div>
  <div class="mb-3 row" *ngIf="getFormControlByIndex(0)">
    <label class="col-md-4 col-form-label" for="text-input">
      {{getFormControlByIndex(0).value ? getLocalizedProjectOptionLabel(getFormControlByIndex(0).value.localizations) : ''}}:
    </label>
    <div class="col-md-8">
      <textarea name="" id="ang-4" class="form-control" rows="4" spellcheck="false" data-testid="project-settings-description"
        [readonly]="!editEnabled"
        [value]="getFormControlByIndex(0).value?.value || ''"
        (input)="updateOptionValue($event, getFormControlByIndex(0))"
        (blur)="markDirty(getFormControlByIndex(0))"
        [class.is-invalid]="checkControlValidity(getFormControlByIndex(0))"></textarea>
      <div class="invalid-feedback">{{ getFormControlByIndex(0)?.errors?.messageKey | translate:{'0':getFormControlByIndex(0)?.errors?.param} }}</div>
    </div>
  </div>
  <div [collapse]="isCollapsed">
    <div class="mb-3 row">
      <div class="col-md-12">
        <hr>
      </div>
    </div>
    <div class="mb-3 row" *ngIf="getFormControlByIndex(1)">
      <label class="col-md-4 col-form-label" for="text-input">
        {{getFormControlByIndex(1).value ? getLocalizedProjectOptionLabel(getFormControlByIndex(1).value.localizations) : ''}}:
      </label>
      <div class="col-md-3">
        <input type="text" id="text-input" name="text-input" class="form-control" spellcheck="false"
          [readonly]="!editEnabled"
          [value]="getFormControlByIndex(1).value?.value || ''"
          (input)="updateOptionValue($event, getFormControlByIndex(1))"
          (blur)="markDirty(getFormControlByIndex(1))"
          [class.is-invalid]="checkControlValidity(getFormControlByIndex(1))">
        <div class="invalid-feedback">{{ getFormControlByIndex(1)?.errors?.messageKey | translate:{'0':getFormControlByIndex(1)?.errors?.param} }}</div>
      </div>
    </div>
    <div class="mb-3 row" *ngIf="getFormControlByIndex(2)">
      <label class="col-md-4 col-form-label" for="text-input">
        {{getFormControlByIndex(2).value ? getLocalizedProjectOptionLabel(getFormControlByIndex(2).value.localizations) : ''}}:
      </label>
      <div class="col-md-3">
        <div class="input-group">
          <input type="text" class="form-control" #dp="bsDatepicker" bsDatepicker (bsValueChange)="setDateValue($event)" spellcheck="false"
            [readonly]="!editEnabled"
            [isDisabled]="!editEnabled"
            [bsValue]="dateValue"
            (blur)="markDirty(getFormControlByIndex(2))"
            [class.is-invalid]="checkControlValidity(getFormControlByIndex(2))">
          <span class="input-group-append">
            <button class="btn btn-secondary" type="button" (click)="dp.toggle()" [disabled]="!editEnabled">
              <i class="fa fa-calendar"></i>
            </button>
          </span>
          <div class="invalid-feedback">{{ getFormControlByIndex(2)?.errors?.messageKey | translate:{'0':getFormControlByIndex(2)?.errors?.param} }}</div>
        </div>
      </div>
    </div>
    <div class="mb-3 row" *ngIf="getFormControlByIndex(3)">
      <label class="col-md-4 col-form-label" for="text-input">
        {{getFormControlByIndex(3).value ? getLocalizedProjectOptionLabel(getFormControlByIndex(3).value.localizations) : ''}}:
      </label>
      <div class="col-md-8">
        <input type="text" id="text-input" name="text-input" class="form-control" spellcheck="false"
          [readonly]="!editEnabled"
          [value]="getFormControlByIndex(3).value?.value || ''"
          (input)="updateOptionValue($event, getFormControlByIndex(3))"
          (blur)="markDirty(getFormControlByIndex(3))"
          [class.is-invalid]="checkControlValidity(getFormControlByIndex(3))">
        <div class="invalid-feedback">{{ getFormControlByIndex(3)?.errors?.messageKey | translate:{'0':getFormControlByIndex(3)?.errors?.param} }}</div>
      </div>
    </div>
    <div class="mb-3 row" *ngIf="getFormControlByIndex(4)">
      <label class="col-md-4 col-form-label" for="text-input">
        {{getFormControlByIndex(4).value ? getLocalizedProjectOptionLabel(getFormControlByIndex(4).value.localizations) : ''}}:
      </label>
      <div class="col-md-8">
        <input type="text" id="text-input" name="text-input" class="form-control" spellcheck="false"
          [readonly]="!editEnabled"
          [value]="getFormControlByIndex(4).value?.value || ''"
          (input)="updateOptionValue($event, getFormControlByIndex(4))"
          (blur)="markDirty(getFormControlByIndex(4))"
          [class.is-invalid]="checkControlValidity(getFormControlByIndex(4))">
        <div class="invalid-feedback">{{ getFormControlByIndex(4)?.errors?.messageKey | translate:{'0':getFormControlByIndex(4)?.errors?.param} }}</div>
      </div>
    </div>
    <div class="mb-3 row" *ngIf="getFormControlByIndex(5)">
      <label class="col-md-4 col-form-label" for="text-input">
        {{getFormControlByIndex(5).value ? getLocalizedProjectOptionLabel(getFormControlByIndex(5).value.localizations) : ''}}:
      </label>
      <div class="col-md-8">
        <input type="text" id="text-input" name="text-input" class="form-control" spellcheck="false"
          [readonly]="!editEnabled"
          [value]="getFormControlByIndex(5).value?.value || ''"
          (input)="updateOptionValue($event, getFormControlByIndex(5))"
          (blur)="markDirty(getFormControlByIndex(5))"
          [class.is-invalid]="checkControlValidity(getFormControlByIndex(5))">
        <div class="invalid-feedback">{{ getFormControlByIndex(5)?.errors?.messageKey | translate:{'0':getFormControlByIndex(5)?.errors?.param} }}</div>
      </div>
    </div>
    <div class="mb-3 row">
      <div class="col-md-12">
        <hr>
      </div>
    </div>
    <div class="mb-3 row" *ngIf="getFormControlByIndex(6)">
      <label class="col-md-4 col-form-label" for="text-input">
        {{getFormControlByIndex(6).value ? getLocalizedProjectOptionLabel(getFormControlByIndex(6).value.localizations) : ''}}:
      </label>
      <div class="col-md-3">
        <input type="text" id="text-input" name="text-input" class="form-control" spellcheck="false"
          [readonly]="!editEnabled"
          [value]="getFormControlByIndex(6).value?.value || ''"
          (input)="updateOptionValue($event, getFormControlByIndex(6))"
          (blur)="markDirty(getFormControlByIndex(6))"
          [class.is-invalid]="checkControlValidity(getFormControlByIndex(6))">
        <div class="invalid-feedback">{{ getFormControlByIndex(6)?.errors?.messageKey | translate:{'0':getFormControlByIndex(6)?.errors?.param} }}</div>
      </div>
    </div>
    <div class="mb-3 row" *ngIf="getFormControlByIndex(7)">
      <label class="col-md-4 col-form-label" for="text-input">
        {{getFormControlByIndex(7).value ? getLocalizedProjectOptionLabel(getFormControlByIndex(7).value.localizations) : ''}}:
      </label>
      <div class="col-md-8">
        <textarea name="" id="ang-4" class="form-control" rows="4" spellcheck="false"
          [readonly]="!editEnabled"
          [value]="getFormControlByIndex(7).value?.value || ''"
          (input)="updateOptionValue($event, getFormControlByIndex(7))"
          (blur)="markDirty(getFormControlByIndex(7))"
          [class.is-invalid]="checkControlValidity(getFormControlByIndex(7))"></textarea>
        <div class="invalid-feedback">{{ getFormControlByIndex(7)?.errors?.messageKey | translate:{'0':getFormControlByIndex(7)?.errors?.param} }}</div>
      </div>
    </div>
    <div class="mb-3 row">
      <div class="col-md-12">
        <hr>
      </div>
    </div>
    <div class="mb-3 row" *ngIf="getFormControlByIndex(8)">
      <label class="col-md-4 col-form-label" for="text-input">
        {{getFormControlByIndex(8).value ? getLocalizedProjectOptionLabel(getFormControlByIndex(8).value.localizations) : ''}}:
      </label>
      <div class="col-md-8">
        <textarea name="" id="ang-4" class="form-control" rows="4" spellcheck="false"
          [readonly]="!editEnabled"
          [value]="getFormControlByIndex(8).value?.value || ''"
          (input)="updateOptionValue($event, getFormControlByIndex(8))"
          (blur)="markDirty(getFormControlByIndex(8))"
          [class.is-invalid]="checkControlValidity(getFormControlByIndex(8))"></textarea>
        <div class="invalid-feedback">{{ getFormControlByIndex(8)?.errors?.messageKey | translate:{'0':getFormControlByIndex(8)?.errors?.param} }}</div>
      </div>
    </div>
  </div>
  <div class="text-end pb-3">
    <div *ngIf="isCollapsed; then thenBlock else elseBlock"></div>
    <ng-template #thenBlock>
      <a (click)="isCollapsed = !isCollapsed">
        {{'configurationCreation.mounting_rail.label.show_more_properties' | translate}}
        <i class="mdi mdi-chevron-down"></i>
      </a>
    </ng-template>
    <ng-template #elseBlock>
      <a (click)="isCollapsed = !isCollapsed">
        {{'configurationCreation.mounting_rail.label.show_less_properties' | translate}}
        <i class="mdi mdi-chevron-up"></i>
      </a>
    </ng-template>
  </div>
</form>
